<template>
  <div style="height: 100%;overflow-x: auto">
    <a-card title="基本信息" :bordered="false">
      <a-row :gutter="16">
        <a-col class="gutter-row" :span="6">
          <label>订单编号：</label>
          <span>{{detail.sNo}}</span>
        </a-col>
        <a-col class="gutter-row" :span="6">
          <label>订单状态：</label>
          <span>{{detail.r_status}}</span>
        </a-col>
        <a-col class="gutter-row" :span="6">
          <label>配送费用：</label>
          <span>{{z_freight}}</span>
        </a-col>
        <a-col class="gutter-row" :span="6">
          <label>订单来源：</label>
          <span>{{detail.source }}</span>
        </a-col>
      </a-row>
      <a-row :gutter="16">
        <a-col class="gutter-row" :span="6">
          <label>支付方式：</label>
          <span>{{detail.paytype}}</span>
        </a-col>
        <a-col class="gutter-row" :span="6">
          <label>下单时间：</label>
          <span>{{detail.add_time}}</span>
        </a-col>
        <a-col class="gutter-row" :span="6">
          <label>付款时间：</label>
          <span>{{detail.pay_time}}</span>
        </a-col>
        <a-col class="gutter-row" :span="6">
          <label>发货时间：</label>
          <span>{{detail.deliver_time}}</span>
        </a-col>
      </a-row>
      <a-row>
        <a-col :span="24">
          <label>到货时间：</label>
          <span>{{detail.arrive_time}}</span>
        </a-col>
      </a-row>
      <a-row>
        <a-col :span="24">
          <label>快递单号：</label>
          <span v-for="(item,index) in detail.courier_num">
             {{item.kuaidi_name}}（{{item.num}}）{{index < detail.courier_num.length - 1 ? ',' : ''}}
           </span>
        </a-col>
      </a-row>
    </a-card>
    <div class="background"></div>
    <a-card title="收货人信息" :bordered="false">
      <a-row>
        <a-col :span="24">
          <label>收货人：</label>
          <span>{{detail.name}}</span>
        </a-col>
      </a-row>
      <a-row>
        <a-col :span="24">
          <label>联系电话：</label>
          <span>{{detail.mobile}}</span>
        </a-col>
      </a-row>
      <a-row>
        <a-col :span="24">
          <label>收货地址：</label>
          <span>{{detail.address}}</span>
        </a-col>
      </a-row>
      <a-row>
        <a-col :span="24">
          <label>备注信息：</label>
          <span>{{detail.remarks}}</span>
        </a-col>
      </a-row>
    </a-card>
    <div class="background"></div>
    <a-card title="商品信息"  :bordered="false">
      <a-table :columns="columns" :data-source="datasource"  :scroll="{ x: 1350,y: 500 }">
        <template slot="p_name" slot-scope="text, record">
          <div class="info">
            <img :src="record.pic" width="60" height="60" alt="">
            <span>{{record.p_name}}</span>
          </div>

        </template>
        <template slot="re_list" slot-scope="text, record">
          <span v-if="record.re_list.length > 0">{{record.re_list[0].re_name}}</span>
        </template>
        <template slot="action" slot-scope="text, record">
          <a v-if="record.re_list.length > 0" @click="view(record.re_list[0].id)">退款详情</a>
        </template>
      </a-table>
      <div class="bottom">
        <div class="bottomItem">
          <span>商品总价：</span>
          <p>¥{{spz_price}}</p>
        </div>
        <div class="bottomItem">
          <span>运费：</span>
          <p>¥{{z_freight}}</p>
        </div>
        <div class="bottomItem">
          <span>店铺优惠：</span>
          <p>-¥{{coupon_price}}</p>
        </div>
        <div class="bottomItem">
          <span>平台优惠：</span>
          <p>-¥{{preferential_amount}}</p>
        </div>
        <div class="bottomItem total">
          <span>合计支付：</span>
          <p>¥{{detail.z_price}}</p>
        </div>
      </div>
    </a-card>
  </div>
</template>

<script>
export default {
  name: "see",
  data () {
    return {
      detail: '',
      sNo: '',
      columns: [],
      datasource: [],
      coupon_price: '',
      preferential_amount: '',
      spz_price: '',
      z_freight: '',
    }
  },
  mounted() {
    this.columns = [
      {
        title: "商品名称",
        key: "p_name",
        dataIndex: "p_name",
        align: 'center',
        scopedSlots: { customRender: "p_name" },
        width: 200
      },
      {
        title: "商品名称",
        key: "size",
        dataIndex: "size",
        align: 'center',
      },
      {
        title: "商品id",
        key: "p_id",
        dataIndex: "p_id",
        align: 'center',
      },
      {
        title: "单价",
        key: "p_price",
        dataIndex: "p_price",
        align: 'center',
      },
      {
        title: "数量",
        key: "num",
        dataIndex: "num",
        align: 'center',
      },
      {
        title: "运费",
        key: "freight",
        dataIndex: "freight",
        align: 'center',
      },
      {
        title: "小计",
        key: "subtotal",
        dataIndex: "subtotal",
        align: 'center',
      },
      {
        title: "退款状态",
        key: "re_list",
        dataIndex: "re_list",
        scopedSlots: { customRender: "re_list" },
        align: 'center',
      },
      {
        title: "操作",
        key: "action",
        dataIndex: "action",
        scopedSlots: { customRender: "action" },
        align: 'center',
        fixed: 'right',
        width: 150
      }
    ]
    this.sNo = this.$route.query.sNo
    this._axios()
  },
  methods: {
    view(id) {
      this.$router.push('see/Refund?id=' + id + '&sNo=' + this.sNo);
    },
    _axios() {
      let data = {
        sNo: this.sNo
      }
      let url = '?module=pc_api&action=order&m=SettlementDetail'
      this.$request.post(url,data).then(res => {
        if (res.code == 200) {

          let otype;
          switch(res.data.data.otype) {
            case 'VI':
              otype = '虚拟订单';
              break;
            case 'JP':
              otype = '竞拍订单';
              break;
            case 'MS':
              otype = '秒杀订单';
              break;
            case 'PT':
              otype = '拼团订单';
              break;
            case 'integral':
              otype = '积分订单';
              break;
            case 'FX':
              otype = '分销订单';
              break;
            case 'PP':
              otype = '拼团订单';
              break;
            case 'PM':
              otype = '秒杀订单';
              break;
            case 'KJ':
              otype = '砍价订单';
              break;
            default:
              otype = '普通订单';
          }
          let source;
          switch(res.data.data.source) {
            case '1':
              source = '微信小程序';
              break;
            case 2:
              source = 'APP';
              break;
            case 3:
              source = '支付宝小程序';
              break;
            case 4:
              source = '头条小程序';
              break;
            case 5:
              source = '百度小程序';
              break;
            case 6:
              source = 'PC商城';
              break;
            case '7':
              source = 'h5移动端';
              break;
              // default:
              // 	source = '';
          }
          this.detail = res.data.data
          this.datasource = res.data.detail
          this.detail.otype = otype
          this.detail.source = source

          this.z_freight = res.data.detail[0].z_freight
          this.spz_price = res.data.spz_price
          this.coupon_price = res.data.coupon_price
          this.preferential_amount = res.data.preferential_amount
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
label {
  color: #888F9E;
  font-size: 14px;
}
.background {
  height: 10px;
  background: #ecedf3;
}
.info {
  display: flex;
  align-items: center;
  span {
    margin-left: 10px;
    text-align: left;
  }
}
.bottom {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 22px;
}
.bottom .bottomItem {
  display: flex;
  width: 100%;
}
.bottom .bottomItem span {
  color: #414658;
  flex: 1;
  text-align: right;
}
.bottom .bottomItem p {
  width: 200px;
  display: inline-block;
  text-align: right;
  font-size: 14px;
  font-weight: 400;
  color: #323544;
}
.total span{
  font-size: 16px;
  font-weight: bold;
}
.total p {
  font-size: 16px!important;
  font-weight: bold!important;
  color: #FF453D!important;
}
/deep/ .ant-row {
  margin-bottom: 25px;
}
/deep/ .ant-card {
  height: auto;
}
/deep/ .ant-card-body {
  padding: 24px!important;
}
</style>